<template>
  <div class="unit-block-wrapper unit-info-block">
    <slot name="mobilt-swiper" />
    <span class="title-info">
      <h5 class="text-subtitle text-bold text-sans">
        {{ props.propertyInfo?.name ?? $t("search_card.fr_noname") }}
      </h5>
      <span class="title-info-loc">
        <span class="location">
          <button @click="openGoogleMap(props.propertyInfo?.coords)">
            <base-icon name="base/MapPin" size="16px" />
          </button>
          <button
            class="text-body-2 text-sans text-regular text-black-monochrome-60 loc-butt"
            :class="{ 'loc-butt': props.propertyInfo?.location }"
            @click="openGoogleMap(props.propertyInfo?.coords)"
          >
            {{ props.propertyInfo?.location ?? $t("search_card.fr_loc") }}
          </button>
        </span>
        <!-- Rating hidden in iteration 1 -->
        <span
          v-if="false"
          class="rating"
          @click="sendRating(props.propertyInfo?.rating)"
        >
          <base-icon name="base/StarFull" size="13px" color="#F59914" />
          <p class="text-body-2 text-sans text-regular">
            {{ props.propertyInfo?.rating }}
          </p>
        </span>
      </span>
    </span>
    <q-separator class="separator" />
    <span class="list-gridbox">
      <span class="list-flexbox">
        <span class="wrapper-flex">
          <p class="text-body-1 text-sans text-regular">
            {{ getPriceTitle }}
          </p>
        </span>
        <span class="text-body-1 text-sans text-bold" style="display: flex; align-items: center">
          <p v-if="isLocalCurrency">≈</p>

          {{
            BASE_CURRENCY.symbol +
            formatPrice(props.propertyInfo?.priceUSD, true, isLocalCurrency, {
              price: props.propertyInfo?.price,
              currency: props.propertyInfo?.currency,
            })
          }}
        </span>
      </span>
      <span v-if="isLocalCurrency" class="list-flexbox">
        <span class="wrapper-flex" style="margin-left: auto">
          <span class="text-body-2 text-sans text-regular text-black-monochrome-60">
            {{
              currentCurrencyDisplay + formatPrice(props.propertyInfo?.price)
            }}
          </span>
          <base-tooltip
            :tooltip-text="`${$t('search_card.fr_operates', { currency: currentCurrency.code })}<br> ${$t('search_card.fr_rate')} `"
            style="margin-bottom: 1px"
          >
            <template #icon>
              <suspense>
                <base-icon
                  name="base/Info"
                  size="16px"
                  color="var(--black-monochrome-60)"
                />
              </suspense> </template
          ></base-tooltip>
        </span>
      </span>
    </span>
    <span class="list-gridbox">
      <span class="list-flexbox">
        <span class="wrapper-flex">
          <p class="text-body-1 text-sans text-regular">
            {{ $t("search_filters.fr_price") }}
          </p>
        </span>
        <span class="text-body-1 text-sans text-bold" style="display: flex; align-items: center">
          <p v-if="isLocalCurrency">≈</p>

          {{
            BASE_CURRENCY.symbol +
            formatPrice(
              props.propertyInfo?.tokenomics?.priceUSD,
              false,
              isLocalCurrency,
              {
                price: props.propertyInfo?.tokenomics?.price,
                currency: props.propertyInfo?.currency,
              }
            )
          }}
        </span>
      </span>
      <span v-if="isLocalCurrency" class="list-flexbox">
        <span class="wrapper-flex" style="margin-left: auto">
          <span style="display: flex" class="text-body-2 text-sans text-regular text-black-monochrome-60">
            {{
              currentCurrencyDisplay +
              formatPrice(props.propertyInfo?.tokenomics?.price)
            }}
          </span>
          <base-tooltip
            :tooltip-text="
              $t('search_card.fr_operates', { currency: currentCurrency.code })
            "
            style="margin-bottom: 1px"
          >
            <template #icon>
              <suspense>
                <base-icon
                  name="base/Info"
                  size="16px"
                  color="var(--black-monochrome-60)"
                />
              </suspense> </template
          ></base-tooltip>
        </span>
      </span>
    </span>
    <span class="list-gridbox">
      <span class="list-flexbox">
        <span class="wrapper-flex">
          <p class="text-body-1 text-sans text-regular">
            {{ $t("search_filters.fr_min_invest-long") }}
          </p>
        </span>
        <span class="text-body-1 text-sans text-bold" style="display: flex; align-items: center">
          <p v-if="isLocalCurrency">≈</p>

          {{
            BASE_CURRENCY.symbol +
            formatPrice(
              props.propertyInfo?.minimumInvestmentUSD,
              false,
              isLocalCurrency,
              {
                price: props.propertyInfo?.minimumInvestment,
                currency: props.propertyInfo?.currency,
              }
            )
          }}
        </span>
      </span>
      <span v-if="isLocalCurrency" class="list-flexbox">
        <span class="wrapper-flex" style="margin-left: auto">
          <span style="display: flex" class="text-body-2 text-sans text-regular text-black-monochrome-60">
            {{
              currentCurrencyDisplay +
              formatPrice(props.propertyInfo?.minimumInvestment)
            }}
          </span>
          <base-tooltip
            :tooltip-text="
              $t('search_card.fr_operates', { currency: currentCurrency.code })
            "
            style="margin-bottom: 1px"
          >
            <template #icon>
              <suspense>
                <base-icon
                  name="base/Info"
                  size="16px"
                  color="var(--black-monochrome-60)"
                />
              </suspense> </template
          ></base-tooltip>
        </span>
      </span>
    </span>
    <q-separator class="separator" />
    <span v-if="props.type !== 'lands'" class="list-flexbox">
      <span class="wrapper-flex">
        <p class="text-body-1 text-sans text-regular">IRR</p>
        <base-tooltip :tooltip-text="$t('finance.IRR')">
          <template #icon>
            <suspense>
              <base-icon
                name="base/Info"
                size="16px"
                color="var(--black-monochrome-60)"
              />
            </suspense> </template
        ></base-tooltip>
      </span>
      <p v-if="props.propertyInfo?.irr" class="text-body-1 text-sans text-bold">
        {{ formatPercentage(props.propertyInfo?.irr) }}%
      </p>
      <base-apr-irr v-else @click="openIssuer"/>
    </span>
    <span v-if="props.type !== 'lands'" class="list-flexbox">
      <span class="wrapper-flex">
        <span
          v-if="hasYieldData"
          class="yield-dot yield-dot--rental"
          aria-hidden="true"
        />
        <p class="text-body-1 text-sans text-regular">APR</p>
        <base-tooltip :tooltip-text="$t('finance.APR')">
          <template #icon>
            <suspense>
              <base-icon
                name="base/Info"
                size="16px"
                color="var(--black-monochrome-60)"
              />
            </suspense> </template
        ></base-tooltip>
      </span>
      <p v-if="props.propertyInfo?.apr" class="text-body-1 text-sans text-bold">
        {{ formatPercentage(props.propertyInfo?.apr) }}%
      </p>
      <base-apr-irr v-else @click="openIssuer"/>
    </span>

    <span class="list-flexbox">
      <span class="wrapper-flex">
        <span
          v-if="hasYieldData"
          class="yield-dot yield-dot--appreciation"
          aria-hidden="true"
        />
        <p class="text-body-1 text-sans text-regular">
          {{ $t("search_card.fr_growth") }}
        </p>
      </span>
      <p class="text-body-1 text-sans text-bold">
        {{
          formatPercentage(
            props.propertyInfo?.finance?.projectTotalIncome?.subfields
              ?.projectionAppreciation
          )
        }}%
      </p>
    </span>

    <q-separator class="separator" />
    <div v-if="fundedPercent !== null" class="unit-info-block__progress">
      <div class="unit-info-block__progress-header">
        <span class="unit-info-block__progress-pct">
          {{ $t("listing_card.sold_pct", { pct: fundedPercent }) }}
        </span>
        <span
          v-if="dollarsLeftDisplay"
          class="unit-info-block__progress-left"
        >
          {{ $t("listing_card.left_to_invest", { amount: dollarsLeftDisplay }) }}
        </span>
      </div>
      <div class="unit-info-block__progress-track">
        <div
          class="unit-info-block__progress-fill"
          :style="{ width: `${fundedPercent}%` }"
        />
      </div>
    </div>
    <span v-else-if="tokensAvailabilityUnknown" class="list-flexbox">
      <span class="wrapper-flex">
        <p class="text-body-1 text-sans text-regular">
          {{ $t("search_card.fr_tokens_avail") }}
        </p>
      </span>
      <base-apr-irr @click="openIssuer" />
    </span>

    <q-separator class="separator separator-buy" />
    <button
      type="button"
      class="info-block-buy"
      @click="openIssuer"
    >
      {{ buyCtaText }}
    </button>
  </div>
</template>

<script setup lang="ts">
import openGoogleMap from "~/utilities/helpers/map/openGoogleMap";
import {
  formatPrice,
  formatPercentage,
} from "~/utilities/helpers/format-data/number";
import {
  getCurrentCurrency,
  getCurrencyDisplaySymbol,
  BASE_CURRENCY,
} from "~/composables/CURRENCIES";

import type { UnitResponseDTO } from "~/services/swagger/Api";
import type { PropertyTypes } from "~/components/base/navigator/types";
import { redirectByProviderName } from "~/utilities/helpers/strings/redirectByProviderName";
import { buildReferralRedirectUrl } from "~/utilities/helpers/strings/buildReferralRedirectUrl";
import eventBus from "~/utilities/composables/eventBus";

interface IProps {
  propertyInfo: UnitResponseDTO;
  type: PropertyTypes;
}

const props = defineProps<IProps>();
const { t } = useI18n();

const isLocalCurrency = computed(
  () => props.propertyInfo?.currency !== BASE_CURRENCY.value.code
);

const fundedPercent = computed<number | null>(() => {
  const pct = props.propertyInfo?.tokenomics?.availableSupplyPercentage;
  const num = typeof pct === "number" ? pct : parseFloat(String(pct));
  if (!Number.isFinite(num) || num < 0 || num > 100) return null;
  const funded = 100 - num;
  return Math.max(0, Math.min(100, Math.round(funded * 100) / 100));
});

// The unit is tokenized (has a total supply) but the provider can't tell us how many tokens are
// still available — show a "Request" hint (same UX as IRR/APR) instead of a progress bar.
const tokensAvailabilityUnknown = computed<boolean>(() => {
  const totalRaw = props.propertyInfo?.tokenomics?.totalSupply;
  const total =
    totalRaw === null || totalRaw === undefined
      ? NaN
      : parseFloat(String(totalRaw));
  const availableRaw = props.propertyInfo?.tokenomics?.availableSupply;
  const available =
    availableRaw === null || availableRaw === undefined
      ? NaN
      : parseFloat(String(availableRaw));
  return Number.isFinite(total) && total > 0 && !Number.isFinite(available);
});

const formatMoneyShortBase = (value: number): string => {
  const symbol = BASE_CURRENCY.value.symbol;
  if (value >= 1_000_000) {
    const m = value / 1_000_000;
    return `${symbol}${m.toFixed(value % 1_000_000 === 0 ? 0 : 1)}M`;
  }
  if (value >= 1000) {
    return `${symbol}${Math.round(value / 1000)}K`;
  }
  return `${symbol}${Math.round(value).toLocaleString("en-US")}`;
};

const dollarsLeftDisplay = computed(() => {
  const tokensLeftRaw = props.propertyInfo?.tokenomics?.availableSupply;
  const priceUSDRaw = props.propertyInfo?.tokenomics?.priceUSD;
  const tokensLeft =
    typeof tokensLeftRaw === "number"
      ? tokensLeftRaw
      : parseFloat(String(tokensLeftRaw));
  const priceUSD =
    typeof priceUSDRaw === "number"
      ? priceUSDRaw
      : parseFloat(String(priceUSDRaw));
  if (!Number.isFinite(tokensLeft) || !Number.isFinite(priceUSD)) return "";
  if (tokensLeft <= 0 || priceUSD <= 0) return "";
  return formatMoneyShortBase(tokensLeft * priceUSD);
});

const currentCurrency = computed(() =>
  getCurrentCurrency(props.propertyInfo?.currency)
);

const currentCurrencyDisplay = computed(() =>
  getCurrencyDisplaySymbol(currentCurrency.value)
);

const getPriceTitle = computed(() => {
  switch (props.type) {
    case "estates":
      return t("search_card.fr_price");
    case "lands":
      return t("search_card.fr_price_land");
  }
});

const openIssuer = () => {
  redirectByProviderName({
    providerName: props.propertyInfo?.provider?.name,
    providerLink: props.propertyInfo?.provider?.url,
    utmLink:
      buildReferralRedirectUrl(props.propertyInfo?.referral) ||
      props.propertyInfo?.referralLink?.link,
    externalUrl: props.propertyInfo?.externalUrl,
    source: "unit__open_ref__ready_to_invest",
    images: props.propertyInfo?.files,
    logoFile: props.propertyInfo?.provider?.logoFile?.url,
  });
};

const hasExternalTarget = computed(
  () =>
    !!props.propertyInfo?.referralLink?.link ||
    !!props.propertyInfo?.externalUrl ||
    !!props.propertyInfo?.provider?.url
);

const buyCtaText = computed(() => {
  if (hasExternalTarget.value) return t("listing_card.buy_tokens");
  return t("listing_card.invest");
});

const sendRating = (rating: number | undefined) =>{
  eventBus.emit("send-rating", rating);
}
</script>

<style scoped lang="scss">
.unit-info-block {
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  width: 100%;
  max-width: 416px;
  height: fit-content;
  position: sticky;
  top: 24px;
  z-index: 20;
  isolation: isolate;
  background: var(--surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-card);
  .separator {
    width: 100%;
  }
  .separator-buy {
    margin: 12px 0 0;
  }
  .info-block-buy {
    @include ds-primary;
    width: 100%;
    margin-top: 14px;
    height: 44px;
    padding: 0 16px;
    border-radius: var(--radius-pill);
    font-weight: var(--fw-bold);
    font-size: var(--font-small);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    &:active:not(:disabled) {
      transform: scale(0.985);
    }
  }
  .title-info {
    width: 100%;
    display: grid;
    gap: 4px;
    align-items: center;
    justify-items: flex-start;
    &-loc {
      width: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      gap: 15px;
      .location {
        display: flex;
        align-items: flex-start;
        gap: 4px;
        button {
          @include drop-button-styles;
        }
        .loc-butt {
          white-space: normal;
          text-align: left;
          word-break: break-word;
        }
      }
      .rating {
        display: flex;
        align-items: center;
        gap: 6px;
        line-height: 1;
        cursor: pointer;
      }
    }
  }
  .list-gridbox {
    width: 100%;
    display: grid;
    align-items: center;
    justify-items: flex-start;
    gap: 4px;
  }
  .list-flexbox {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    cursor: default;
    .wrapper-flex {
      display: flex;
      gap: 4px;
      align-items: center;
      justify-content: flex-start;
    }
  }
  &__progress {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  &__progress-header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 8px;
    min-width: 0;
  }
  &__progress-pct {
    font-size: var(--font-small);
    font-weight: var(--fw-bold);
    color: var(--text-primary);
    white-space: nowrap;
  }
  &__progress-left {
    font-size: var(--font-micro);
    color: var(--text-secondary);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
  }
  &__progress-track {
    width: 100%;
    height: 6px;
    background: var(--border-subtle);
    border-radius: var(--radius-pill);
    overflow: hidden;
  }
  &__progress-fill {
    height: 100%;
    background: var(--accent-primary);
    border-radius: var(--radius-pill);
    transition: width 0.4s ease;
  }
}

@media (max-width: 59rem) {
  .unit-info-block {
    padding: 0;
    background: transparent;
    border: none;
    border-radius: 0;
    box-shadow: none;
  }
}
</style>
